module.exports = __webpack_public_path__ + "img/imagemaids.b0104e06.jpg";